import axios from "axios"
import { cuentaContableCuentaAdapter } from "./CuentaContable_Cuenta.service.adapter"
import { CuentaContableCuentaReadingDtoProps } from "./DTOs/CuentaContableCuentaReadingDto"
import { CategoriaCuentaContableEnumType } from "./Types/CategoriaCuentaContableEnum"

export async function getEntidadCuentaContableCuenta(
  entidad?: CategoriaCuentaContableEnumType
): Promise<CuentaContableCuentaReadingDtoProps[]> {
  const { data } = await axios.get(
    `CuentaContable_Cuenta/entidad/${entidad ?? ""}`
  )

  return data?.map((movimiento: CuentaContableCuentaReadingDtoProps) =>
    cuentaContableCuentaAdapter(movimiento)
  )
}
